import React from "react";
import { motion } from "framer-motion";

function AuditBenefits() {
  const benefits = [
    {
      title:
        "SEO Opportunity Analysis",
      description:
        "Discover ranking opportunities, keyword gaps and visibility improvements."
    },
    {
      title:
        "Website Performance Review",
      description:
        "Identify UX, performance and conversion bottlenecks affecting growth."
    },
    {
      title:
        "Lead Generation Assessment",
      description:
        "Evaluate how effectively your website captures and converts visitors."
    },
    {
      title:
        "Competitor Benchmarking",
      description:
        "Understand how your digital presence compares against competitors."
    },
    {
      title:
        "Growth Recommendations",
      description:
        "Receive practical recommendations prioritized by impact."
    },
    {
      title:
        "90-Day Action Roadmap",
      description:
        "Clear next steps you can execute immediately."
    }
  ];

  return (
    <section
      style={{
        padding: "100px 24px",
        background: "#f8fbfd"
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto"
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "60px"
          }}
        >
          <span
            style={{
              color: "#21b573",
              fontWeight: 700,
              textTransform:
                "uppercase"
            }}
          >
            Benefits
          </span>

          <h2
            style={{
              color: "#002147",
              fontWeight: 700,
              marginTop: "18px",
              fontSize:
                "clamp(2rem,4vw,3.2rem)"
            }}
          >
            Everything We Review
          </h2>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(300px,1fr))",
            gap: "24px"
          }}
        >
          {benefits.map((item) => (
            <motion.div
              key={item.title}
              whileHover={{
                y: -8
              }}
              style={{
                background: "#fff",
                border:
                  "1px solid rgba(0,33,71,.08)",
                borderRadius: "24px",
                padding: "32px",
                boxShadow:
                  "0 15px 40px rgba(0,33,71,.06)"
              }}
            >
              <h4
                style={{
                  color: "#002147",
                  fontWeight: 700,
                  marginBottom: "16px"
                }}
              >
                {item.title}
              </h4>

              <p
                style={{
                  color: "#6e6e73",
                  lineHeight: 1.8,
                  marginBottom: 0
                }}
              >
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AuditBenefits;